    <!-- <ngx-barcode class="barcode" [bc-value]="renderValue" [bc-width]="2" [bc-height]="30" [bc-font-size]="10" [bc-display-value]="true"></ngx-barcode> -->
      <input type="text"  [disabled]="disabledInput" [(ngModel)]="id_value"
      (keydown.enter)="onEnter()" (keydown.tab)="onEnter()" #dosimeter_id 
      nbInput fullWidth (change)="textChange($event)" fieldSize="medium">